/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Kpi_Total_RevenueInputs */

const vi_report_kpi_total_revenue = /** @type {(inputs: Report_Kpi_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng doanh thu`)
};

/**

* @param {Report_Kpi_Total_RevenueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_kpi_total_revenue = /** @type {((inputs?: Report_Kpi_Total_RevenueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Kpi_Total_RevenueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_kpi_total_revenue(inputs)
});